"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalogue = void 0;
var react_1 = require("react");
var CatalogueProvider_1 = require("../context/CatalogueProvider");
var useCatalogue = function () {
    return (0, react_1.useContext)(CatalogueProvider_1.CatalogueContext);
};
exports.useCatalogue = useCatalogue;
